var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup4731WaitListComingSoon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 158,
    viewBox: "0 0 239 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.775 8.00498L121.688 0.917924L122.605 0L130.611 8.00534L122.605 16.0046L121.688 15.0863L128.775 8.00498Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238.999 135.153H16.5879C16.5879 73.7353 66.3786 23.9446 127.797 23.9446C189.215 23.9446 238.999 73.7353 238.999 135.153Z",
    fill: "#6BB6FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8633 135.147C42.8633 88.2412 80.8904 50.22 127.791 50.22C174.691 50.22 212.718 88.2471 212.718 135.147H42.8633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M238.999 135.153H16.5879C16.5879 73.7353 66.3786 23.9446 127.797 23.9446C189.215 23.9446 238.999 73.7353 238.999 135.153Z",
    fill: "#6BB6FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8633 135.147C42.8633 88.2412 80.8904 50.22 127.791 50.22C174.691 50.22 212.718 88.2471 212.718 135.147H42.8633Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1895 135.147C72.1895 104.441 97.0848 79.5459 127.791 79.5459C158.497 79.5459 183.392 104.441 183.392 135.147H72.1895Z",
    fill: "#6BB6FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.797 135.153H16.5879V157.348H127.797V135.153Z",
    fill: "#006EF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M239 135.153H127.797V157.348H239V135.153Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.465 128.561C156.951 130.681 157.206 132.885 157.206 135.153H152.147L156.465 128.561Z",
    fill: "#6BB6FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.18 103.026L156.465 128.561C153.77 116.785 144.015 107.711 131.89 106.023L158.355 88.6975C164.142 92.5061 169.176 97.375 173.18 103.026Z",
    fill: "#6BB6FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.206 135.153H152.147L156.465 128.561C156.951 130.681 157.206 132.885 157.206 135.153Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.896 102.629L155.861 126.334C152.117 114.398 140.964 105.739 127.797 105.739C127.163 105.739 126.541 105.756 125.919 105.798L153.61 85.8958C161.263 89.9117 167.867 95.6632 172.896 102.629Z",
    fill: "#00EC25"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149.517 135.153L218.363 39.3569L105.158 120.713L119.593 135.153H149.517Z",
    fill: "#00EC25"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M172.896 102.629L155.861 126.334C152.117 114.398 140.964 105.739 127.797 105.739C127.163 105.739 126.541 105.756 125.919 105.798L153.61 85.8958C161.263 89.9117 167.867 95.6632 172.896 102.629Z",
    fill: "#091F83"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3819 135.147C98.3819 118.906 111.549 105.739 127.791 105.739C144.032 105.739 157.2 118.906 157.2 135.147H98.376H98.3819Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.724 135.153H183.398C183.398 104.441 158.503 79.5459 127.797 79.5459C97.0905 79.5459 72.1951 104.441 72.1951 135.153H42.8633C42.8633 88.2471 80.8904 50.22 127.797 50.22C174.703 50.22 212.724 88.2471 212.724 135.153Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.607 77.9822L172.896 102.629C167.868 95.663 161.263 89.9116 153.61 85.8956L179.175 67.5217C183.298 70.6551 187.124 74.1617 190.607 77.9822Z",
    fill: "#00EC25"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M190.607 77.9822L172.896 102.629C167.868 95.663 161.263 89.9116 153.61 85.8956L179.175 67.5217C183.298 70.6551 187.124 74.1617 190.607 77.9822Z",
    fill: "#00EC25"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M218.369 39.3569L206.197 56.2915L190.607 77.9823C187.124 74.1618 183.297 70.6553 179.175 67.5219L201.251 51.6595L218.369 39.3569Z",
    fill: "#00EC25"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206.197 56.2914L190.607 77.9823C187.124 74.1618 183.297 70.6552 179.175 67.5218L201.251 51.6594C202.945 53.1521 204.597 54.6921 206.197 56.2914Z",
    fill: "#091F83"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.797 8.6541C57.9357 8.6541 1.29814 65.2858 1.29814 135.147H0C0 64.5688 57.2188 7.35596 127.797 7.35596V8.6541Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup4731WaitListComingSoon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group4731_WaitListComingSoon.c4497b5f4e7052dc47666fbca75f6c8a.svg";